export class MenuSlider extends Phaser.GameObjects.Container {
    constructor(scene, x, y, options = {}) {
        super(scene, x, y);
        
        const {
            initialValue = 50,
            onChange = () => {},
            label = '',
            minX = 4,  // Visual padding for knob
            maxX = -4  // Negative value subtracted from channel width
        } = options;
        
        this.initialValue = initialValue;
        this.onChange = onChange;
        this.label = label;
        this.minX = minX;
        this.maxX = maxX;
 
        scene.load.image('sliderChannel', '/sprites/ui/Menu/sliderChannel.png');
        scene.load.image('sliderKnob', '/sprites/ui/Menu/slider.png');
        scene.load.once('complete', () => {
            this.buildSlider(scene);
        });
        scene.load.start();
    }
 
    buildSlider(scene) {
        if (this.label) {
            this.labelText = scene.add.text(0, -20, this.label, { 
                fontSize: '12px',
                color: '#000000'
            });
            this.add(this.labelText);
        }
 
        this.channel = scene.add.sprite(0, 0, 'sliderChannel');
        this.channel.setOrigin(0, 0.5);
 
        this.knob = scene.add.sprite(0, 0, 'sliderKnob');
        this.knob.setOrigin(0.5);
        
        this.valueText = scene.add.text(this.channel.width + 8, -8, `${this.initialValue}%`, {
            fontSize: '12px',
            color: '#000000'
        });
        
        this.knob.setInteractive({ draggable: true });
        this.setupDrag();
        this.setValue(this.initialValue);
        
        this.add([this.channel, this.knob, this.valueText]);
        scene.add.existing(this);
    }
 
    setupDrag() {
        this.knob.on('drag', (pointer, dragX) => {
            const minX = this.minX;
            const maxX = this.channel.width + this.maxX;
            this.knob.x = Phaser.Math.Clamp(dragX, minX, maxX);
            const value = this.getValue();
            this.valueText.setText(`${value}%`);
            this.onChange(value);
        });
    }
 
    setValue(value) {
        const normalizedValue = Phaser.Math.Clamp(value, 0, 100);
        const range = this.channel.width + this.maxX - this.minX;
        this.knob.x = this.minX + (normalizedValue / 100) * range;
        this.valueText.setText(`${normalizedValue}%`);
    }
 
    getValue() {
        const range = this.channel.width + this.maxX - this.minX;
        return Math.round(((this.knob.x - this.minX) / range) * 100);
    }
 }